module.exports = __webpack_public_path__ + "static/media/visit.290a9962.svg";